import Stack from "@mui/material/Stack";

interface Props {
  children: React.ReactNode;
  gap?: number | string;
}

const Centered = ({ children, gap }: Props) => {
  return (
    <Stack
      height="100%"
      width="100%"
      alignItems="center"
      justifyContent="center"
      gap={gap}
    >
      {children}
    </Stack>
  );
};

export default Centered;
